export default __webpack_public_path__ + "static/media/btn_close.1ad1b352.png";